import { render, staticRenderFns } from "./autocomplete-uf.vue?vue&type=template&id=7f1eabb2&lang=pug&"
import script from "./autocomplete-uf.vue?vue&type=script&lang=ts&"
export * from "./autocomplete-uf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports